
import { Component, Vue, Watch } from "vue-property-decorator";
import QuestionCard from "@/components/question/QuestionCard.vue";
import UploadArea from "@/components/upload/UploadArea.vue";
import Select from "@/components/select/select.vue";
import { first } from "lodash";
import QRCode from "qrcodejs2"; //
import SW from "@/components/form/switch.vue";

@Component({
  components: {
    QuestionCard,
    UploadArea,
    Select,
    SW
  }
})
export default class CssText extends Vue {
  $refs!: { input: HTMLFormElement };
  t = "";
  showTextUp = false;
  showTextDown = true;
  mounted() {
    this.getQR();
  }

  @Watch("t")
  tt(n: any, o: any) {
    if (o === "" && n !== "") {
      this.TU();
    }
    if (o !== "" && n === "") {
      this.TD();
    }
  }
  TU() {
    this.showTextDown = false;
    this.showTextUp = true;
  }

  TD() {
    this.showTextDown = true;
    this.showTextUp = false;
  }

  getQR() {
    new QRCode("qr", {
      width: 100,
      height: 100,
      text: "http://www.baidu.com", // 二维码地址
      colorDark: "gray",
      colorLight: "white"
    });
  }

  handleFalse() {
    return false;
  }

  compute() {
    this.endTime = new Date();
    if (!this.beginTime) {
      this.beginTime = new Date();
    }
    this.usedTime = Math.floor((this.endTime - this.beginTime) / 1000);
    this.inputNumber = this.$refs.input.value.length;
    this.rate = this.getRate(this.text1, this.$refs.input.value);
  }
  getRate(text1: any, text2: any) {
    if (text1.length < this.minLength || text2.length < this.minLength)
      return 0;
    this.speed = Math.round(
      (Number(this.inputNumber) / (Number(this.usedTime) || 1)) * 60
    ); //防止只打一个字出现 无限大
    const set1 = new Set(text1);
    const set2 = new Set(text2);
    const union = new Set([...set1, ...set2]);
    const intersect = new Set([...set1].filter(x => set2.has(x)));
    return Math.round((intersect.size / union.size) * 100);
  }
  minLength = 5;
  value = "";
  text1 =
    "北国风光，千里冰封，万里雪飘。望长城内外，惟余莽莽；大河上下，顿失滔滔。山舞银蛇，原驰蜡象，欲与天公试比高。须晴日，看红装素裹，分外妖娆。江山如此多娇，引无数英雄竞折腰。惜秦皇汉武，略输文采；唐宗宋祖，稍逊风骚。一代天骄，成吉思汗，只识弯弓射大雕。俱往矣，数风流人物，还看今朝。";
  beginTime: any;
  endTime: any;
  inputNumber = 0;
  usedTime = 0;
  rate = 0;
  speed = 0;
  answer = "";
  radio = 6;
  radio2 = "1";
  time = "";
  text = "nihao1";
  input3 = "你好啊";
  selects = [];
  checkList = ["选中且禁用", "复选框 A"];
  inputValue = "";
  searchInputValue = "";
  options = [
    { value: "1", label: "东风-31" },
    { value: "2", label: "东风-41" },
    { value: "3", label: "东风-17" },
    { value: "4", label: "东风-21D" },
    { value: "5", label: "东风-5B" }
  ];
  //下拉搜索匹配
  get getOptions() {
    if (this.searchInputValue) {
      return this.options.filter(d => d.label.includes(this.searchInputValue));
    } else {
      return this.options;
    }
  }
  test = 2;
  inp() {
    this.$message.success("switch变化了");
  }
  tableData = [
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    },
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    },
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    },
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    },
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    },
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    },
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    }
  ];
  questions = [
    {
      type: 5, //填空
      blankQuestionConfig: {
        answerList: [
          { score: 0, words: "小名" },
          { score: 0, words: "没错" }
        ],
        desc: "我的名字（），这个智能啊（）<p></p>",
        ignoreBlank: 1,
        scoreAll: 10,
        scoreType: 1,
        strictOrder: 1
      },
      questionId: 3365
    },
    {
      aiDimensionList: [],
      answers: [
        {
          content: "<p>这是参考答案</p>",
          isRight: 0,
          key: "A",
          keyScore: 0,
          questionAnswerId: 18405,
          sort: 1
        }
      ],
      audioUrl: "",
      companyIndex: 32,
      desc: "<p>这是一道有参考答案的视频题</p>",
      descTextOnly: "这是一道有参考答案的视频题",
      descVideo1: "",
      descVideo2: "",
      descVideoCover1: "",
      descVideoCover2: "",
      difficultLevel: 3,
      isCandidateUsed: 0,
      questionConfig: "",
      questionId: 3367,
      remark: "我是视频题的备注",
      score: 10,
      type: 6,
      videoQuestionConfig: null
    },
    {
      type: 5, //填空
      blankQuestionConfig: {
        answerList: [
          { score: 0, words: "小名" },
          { score: 0, words: "没错" }
        ],
        desc: "我的名字（），这个智能啊（）<p></p>",
        ignoreBlank: 1,
        scoreAll: 10,
        scoreType: 1,
        strictOrder: 1
      },
      questionId: 3365
    },
    {
      type: 1, //单选
      answers: [
        {
          content: "<p>赵云</p>",
          isRight: 0,
          key: "A",
          keyScore: 0,
          questionAnswerId: 18397,
          sort: 1
        },
        {
          content: "<p>秦始皇</p>",
          isRight: 0,
          key: "B",
          keyScore: 0,
          questionAnswerId: 18398,
          sort: 2
        },
        {
          content: "<p>康熙</p>",
          isRight: 1,
          key: "C",
          keyScore: 0,
          questionAnswerId: 18399,
          sort: 3
        },
        {
          content: "<p>商鞅</p>",
          isRight: 0,
          key: "D",
          keyScore: 0,
          questionAnswerId: 18400,
          sort: 4
        }
      ],
      descTextOnly: "这是普通单选题 增确答案是C",
      remark: "这是备注内容",
      score: 5,
      audioUrl: "",
      companyIndex: 30,
      desc: "<p>这是普通单选题 增确答案是C</p>",
      descVideo1: "",
      descVideo2: "",
      descVideoCover1: "",
      descVideoCover2: "",
      difficultLevel: 3,
      isCandidateUsed: 0,
      questionConfig: "",
      questionId: 3365
    },
    {
      type: 1, //单选
      answers: [
        {
          content: "<p>赵云</p>",
          isRight: 0,
          key: "A",
          keyScore: 0,
          questionAnswerId: 18397,
          sort: 1
        },
        {
          content: "<p>秦始皇</p>",
          isRight: 0,
          key: "B",
          keyScore: 0,
          questionAnswerId: 18398,
          sort: 2
        },
        {
          content: "<p>康熙</p>",
          isRight: 1,
          key: "C",
          keyScore: 0,
          questionAnswerId: 18399,
          sort: 3
        },
        {
          content: "<p>商鞅</p>",
          isRight: 0,
          key: "D",
          keyScore: 0,
          questionAnswerId: 18400,
          sort: 4
        }
      ],
      descTextOnly: "这是普通单选题 增确答案是C",
      remark: "这是备注内容",
      score: 5,
      audioUrl: "",
      companyIndex: 30,
      desc: "<p>这是普通单选题 增确答案是C</p>",
      descVideo1: "",
      descVideo2: "",
      descVideoCover1: "",
      descVideoCover2: "",
      difficultLevel: 3,
      isCandidateUsed: 0,
      questionConfig: "",
      questionId: 3365
    }
  ];

  changeRadio(e: string) {
    // this.radio = e;
  }
}
